export var DuplexerEvent;
(function (DuplexerEvent) {
    DuplexerEvent["URL_CHANGED"] = "URL_CHANGED";
    DuplexerEvent["WIDGET_SESSION_EXPIRED"] = "WIDGET_SESSION_EXPIRED";
})(DuplexerEvent || (DuplexerEvent = {}));
export * from './DuplexerSubscriber';
//# sourceMappingURL=index.js.map